// AUTO-GENERATED from servers/common-servers-v2/helpers/FormHelper/meta.js by servers/common-servers-v2/scripts/sync-form-helper.js.
// Do not edit: change the source and run `node scripts/sync-form-helper.js`.
/* eslint-disable */
import { LIMITS } from "./constants.js";
import { clean_string } from "./validate_submission.js";

/*
 * Submission metadata that comes from the client (spec §8, §10, §11). None of it
 * is trusted: it is bounded here and only ever shown escaped in the panel.
 */

const is_plain_object = (value) => value !== null && typeof value === "object" && !Array.isArray(value);

// extra_meta: at most 20 keys, key <= 40 chars, value a string (<= 200), a finite number or a boolean.
// Returns { extra, errors }; `extra` is undefined when empty or invalid.
const validate_extra_meta = (extra, limits = LIMITS) => {
    if (extra === undefined || extra === null) {
        return { extra: undefined, errors: [] };
    }
    if (!is_plain_object(extra)) {
        return { extra: undefined, errors: [{ code: "invalid_extra_meta" }] };
    }
    const keys = Object.keys(extra);
    if (keys.length > limits.EXTRA_META_MAX_KEYS) {
        return { extra: undefined, errors: [{ code: "extra_meta_too_many_keys", max: limits.EXTRA_META_MAX_KEYS }] };
    }
    const errors = [];
    const clean = {};
    keys.forEach((key) => {
        const value = extra[key];
        if (key === "" || key === "__proto__" || key.length > limits.EXTRA_META_KEY_MAX) {
            errors.push({ code: "extra_meta_invalid_key", key: key.slice(0, limits.EXTRA_META_KEY_MAX) });
        } else if (typeof value === "string") {
            const text = clean_string(value);
            if (text.length > limits.EXTRA_META_VALUE_MAX) {
                errors.push({ code: "extra_meta_value_too_long", key, max: limits.EXTRA_META_VALUE_MAX });
            } else {
                clean[key] = text;
            }
        } else if ((typeof value === "number" && Number.isFinite(value)) || typeof value === "boolean") {
            clean[key] = value;
        } else {
            errors.push({ code: "extra_meta_invalid_value", key });
        }
    });
    return { extra: errors.length === 0 && Object.keys(clean).length > 0 ? clean : undefined, errors };
};

// Path + query, never the hash, bounded in length. "" when there is nothing usable.
const clean_page_url = (url, limits = LIMITS) => {
    if (typeof url !== "string") {
        return "";
    }
    let text = clean_string(url);
    const absolute = /^[a-z][a-z0-9+.-]*:\/\/[^/?#]+(.*)$/i.exec(text);
    if (absolute) {
        text = absolute[1] || "/";
    }
    const hash_index = text.indexOf("#");
    if (hash_index >= 0) {
        text = text.slice(0, hash_index);
    }
    return text.slice(0, limits.PAGE_URL_MAX);
};

// Time spent filling the form: a whole number of ms in [0, 24 h], otherwise null.
const clean_duration_ms = (value, limits = LIMITS) => {
    if (typeof value !== "number" || !Number.isFinite(value) || value < 0 || value > limits.DURATION_MAX_MS) {
        return null;
    }
    return Math.round(value);
};

export {
    validate_extra_meta,
    clean_page_url,
    clean_duration_ms,
};
